export enum LayersFilters {
    UNKNOWN = 0,
    AVAILABLE = 1,
    BUSY = 2,
    INACTIVE = 3,
    COMING_SOON = 4,
}
